import LMSAdmin from './LMSAdmin';

export default LMSAdmin;
